//Passkey events
export const passkeyCreationStarted = 'passkeyCreationStarted';
export const passkeyCreated = 'passkeyCreated';